// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3DYpa","notes":"Notes_notes__29Je_"};